import { render, staticRenderFns } from "./ProductsSeguridadPage.vue?vue&type=template&id=5c36fff3&scoped=true&"
import script from "./ProductsSeguridadPage.vue?vue&type=script&lang=js&"
export * from "./ProductsSeguridadPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSeguridadPage.vue?vue&type=style&index=0&id=5c36fff3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36fff3",
  null
  
)

export default component.exports